import { Component, Inject, Vue } from 'vue-property-decorator';

@Component
export default class AdminMenu extends Vue {
  public get openAPIEnabled(): boolean {
    return this.$store.getters.activeProfiles.indexOf('api-docs') > -1;
  }
}
